import type { FC } from "react";
import React from "react";

import type {
  Action,
  ActionAction,
  Maybe,
  Pages,
  WelcomeOfferBannerWelcomeOfferBannerItems,
} from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { WelcomeOfferCard } from "~/features/welcome-offer-banner/components/WelcomeOfferCard";
import { Flex } from "~/shared/ui-kit/flex/Flex";

export type WelcomeOfferCardsProps = {
  data: Array<Maybe<WelcomeOfferBannerWelcomeOfferBannerItems>> | undefined;
  isActionInactive: (action: Action) => boolean;
  getUrl: (page: Pages) => string;
  onCallAction: (action: ActionAction) => void;
  className?: string;
  isFullWidthCard?: (id: ID) => boolean;
};

export const WelcomeOfferCards: FC<WelcomeOfferCardsProps> = ({
  data,
  isActionInactive,
  getUrl,
  onCallAction,
  className,
  isFullWidthCard,
}) => {
  return (
    <Flex
      className={`flex-grow md:flex-grow-0 lg:mt-3.5 ${className}`}
      flexDirection="row"
      justify="center"
      md={{ flexDirection: "column" }}
      gap="16px"
    >
      {data
        ?.filter((card) => {
          if (card?.welcome_offer_banner_items_id?.action) {
            return !isActionInactive(card.welcome_offer_banner_items_id.action);
          }

          return true;
        })
        ?.map((card) => {
          if (!card?.welcome_offer_banner_items_id) return null;

          const action =
            card?.welcome_offer_banner_items_id.action?.action?.[0];
          let href;

          if (isExternalLink(action?.item)) {
            href = action.item.href ?? undefined;
          }

          if (isInternalLink(action?.item)) {
            href = action.item.page ? getUrl(action.item.page) : undefined;
          }

          return (
            <WelcomeOfferCard
              className={`${isFullWidthCard?.(card.id) ? "!w-[312px]" : ""}`}
              href={href}
              key={card.id}
              card={card.welcome_offer_banner_items_id}
              onPress={() => {
                if (action) {
                  onCallAction(action);
                }
              }}
            />
          );
        })}
    </Flex>
  );
};
